const GLOBAL_LIGHT_CONFIG = {
  ambient: {
    enabled: true,
    color: 0x4a2c5e, // Purple-tinted ambient for spooky atmosphere
    intensity: 0.8, // Darker for more dramatic shadows
  },
}

export { GLOBAL_LIGHT_CONFIG };
